import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "regenerator-runtime/runtime.js";
import { defineComponent as _defineComponent } from 'vue';
import { onBeforeMount, ref, watch, nextTick } from 'vue';
import { useRepositories } from '@/plugins/repositories';
import { useTelemetry } from '@/plugins/telemetry';
import { useAuth } from '@/plugins/auth';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup: function setup(__props) {
    var route = useRoute();
    var router = useRouter();
    var $auth = useAuth();
    var $repositories = useRepositories();
    var $telemetry = useTelemetry();
    var category = ref({});
    var subcategories = ref([]);
    onBeforeMount(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var categoryId;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if ($auth.permissions.formatDownload) {
              _context.next = 3;
              break;
            }
            router.push('/');
            return _context.abrupt("return");
          case 3:
            categoryId = route.params.id;
            _context.next = 6;
            return $repositories.format.getCategory(categoryId);
          case 6:
            category.value = _context.sent;
            _context.next = 9;
            return $repositories.format.getSubcategories(categoryId);
          case 9:
            subcategories.value = _context.sent;
          case 10:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    watch(subcategories, function (newVal, oldVal) {
      if (newVal.length > 0 && oldVal.length === 0) {
        nextTick(function () {
          var _document$querySelect;
          var target = document.getElementById(decodeURI(route.hash.replace('#', '')));
          if (!target) return;
          var rect = target.getBoundingClientRect();
          var searchBarHeight = ((_document$querySelect = document.querySelector('nav#search-bar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.clientHeight) || 0;
          window.scrollBy({
            top: rect.top - searchBarHeight,
            behavior: 'smooth'
          });
        });
      }
    });
    function onClickCategory(category) {
      $telemetry.sendClickTelemetry({
        button: 'format-subcategories__category',
        params: {
          format: {
            subcategories: {
              category: category
            }
          }
        }
      }, route);
    }
    function onClickDownload(file) {
      $telemetry.sendClickTelemetry({
        button: 'format-subcategories__file',
        params: {
          format: {
            subcategories: {
              file: file
            }
          }
        }
      }, route);
    }
    function onClickDocument(document) {
      $telemetry.sendClickTelemetry({
        button: 'format-subcategories__document',
        params: {
          format: {
            subcategories: {
              document: document
            }
          }
        }
      }, route);
    }
    return {
      __sfc: true,
      route: route,
      router: router,
      $auth: $auth,
      $repositories: $repositories,
      $telemetry: $telemetry,
      category: category,
      subcategories: subcategories,
      onClickCategory: onClickCategory,
      onClickDownload: onClickDownload,
      onClickDocument: onClickDocument
    };
  }
});